import { Controller } from "stimulus";
import Hls from "hls.js";

export default class extends Controller {
  async connect() {
    this.play = this.play.bind(this);
    this.element.addEventListener('loadedmetadata', this.play);
    this.hls = new Hls();

    // Try to fetch the hls playlist url, if we can't find it then fall back to the original
    this.hlsUrl = this.element.getAttribute('data-playlist-url');
    this.originalUrl = this.element.getAttribute('data-original-url');

    const response = await fetch(this.hlsUrl, { method: 'HEAD' });

    if (response.ok) {
      this.loadHlsUrl();
    } else {
      this.loadOriginalUrl();
    }
  }

  disconnect() {
    if (this.hls) {
      this.hls.destroy();
    }
    this.element.removeEventListener('loadedmetadata', this.play);
  }

  loadHlsUrl() {
    if (this.element.canPlayType('application/vnd.apple.mpegurl')) {
      const url = this.element.getAttribute('data-playlist-url');
      this.element.src = this.hlsUrl;
    } else if (Hls.isSupported()) {
      var video = this.element;
      this.hls.loadSource(this.hlsUrl);
      this.hls.attachMedia(video);
    } else {
      this.loadOriginalUrl();
    }
  }

  loadOriginalUrl() {
    this.element.src = this.originalUrl;
  }

  play() {
    this.element.play();
  }

}